import { forwardRef } from 'react';
import { Label } from './Label';
import { Help } from './Help';

export const Input = forwardRef((props, ref) => {
  const { value, label, help, style, ...rest } = props;
  return (
    <div style={{ width: '100%' }}>
      <Label label={label} />
      <Help help={help} />
      <input
        value={value || ''}
        ref={ref}
        {...rest}
        style={{
          border: '1px solid #ccc',
          background: props.disabled ? '#eee' : 'white',
          padding: '8.5px 10px',
          borderRadius: 4,
          boxShadowx: '2px 2px #0001',
          fontSize: 14,
          ...(props.disabled
            ? {
                background: '#eee',
                color: '#888',
              }
            : {}),
          ...style,
        }}
      />
    </div>
  );
});
